<template>
    <v-container>
        <DayButtons
        v-on:today="getTodayJson()"
        v-on:tomorrow="getTomorrowJson()"
        ></DayButtons>
            
        <v-row >
            <v-col cols="12" sm="6" md="4" class="mb-0 pb-0 pt-0 mt-0" v-for="(singleRestaurant, index) in FOODS" :key="index" >
        
                <v-simple-table class="mb-4">
                <table class="mb-0 pb-0">
                    <thead> 
                        <tr class="lunch-table-header">
                            <th colspan="2" >
                                <p class="mb-0">
                                <a :href=singleRestaurant.URL>
                                    {{ singleRestaurant.RESTAURANT }}
                                </a> 
                                    {{Day}}.{{Month}}.
                                </p>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(dish, index) in singleRestaurant.Dishes" :key="index">
                        <th class="w-33" v-if="dish.length > 1">
                            Ruoka {{ index + 1  }}
                        </th>
                        <td class="w-66" v-if="dish && dish.length > 1">
                            {{ dish }}
                        </td>
                    </tbody>
                </table>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>    
</template>


<script>
//import ruokalista from "http://192.168.0.105:5000/public/ruokalista.json";
import DayButtons from "./dayButtons";

export default {
    name: 'App',
    components: { DayButtons },
    data() {
        return {
            FOODS: '',
            Month: '',
            Day: ''
        }
    },
    methods: {
        getTodayJson() {
            let path = "/foodstoday.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.FOODS = out;
               this.getDate();
            })
            .catch(err => { throw err });
        },
        getTomorrowJson() {
            let path = "/foodstomorrow.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.FOODS = out;
               this.getDate();
            })
            .catch(err => { throw err });
        },
        getDate() {
            var dateList = this.FOODS[0].DATE.split("-");
            let month = dateList[1];
            let day = dateList[2];
            if (month[0] == "0" && month.length == 2) month = month[1];
            if (day[0] == "0" && day.length == 2) day = day[1];
            this.Month = month;
            this.Day = day;
        }
    },
    mounted() {
        this.getTodayJson();
    }
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>